import { sprinklrChatUrl } from "config";

const loadSprinklr = ({
  userServiceId,
  appId,
  userInfo,
  chatHash,
  toggleIsSprinklrChatOpen,
  setSprinklrUnreadMessageCount,
}) => {
  window.sprChatSettings = {
    appId: appId,
    skin: "MODERN",
    user: {
      id: userServiceId,
      ...((userInfo.first_name || userInfo.firstName) && {
        firstName: userInfo.first_name || userInfo.firstName,
      }),
      ...((userInfo.last_name || userInfo.lastName) && {
        lastName: userInfo.last_name || userInfo.lastName,
      }),
      ...(userInfo.email && {
        email: userInfo.email,
      }),
      orgId: userInfo.org_id,
      plan: userInfo.orgPlan,
      ...(userInfo.phoneNumber && {
        phoneNo: userInfo.phoneNumber,
      }),
      // NOTE: Sprinklr not working when profileImageUrl is added
      // ...(userInfo.profile_image && {
      //   profileImageUrl: userInfo.profile_image,
      // }),
      hash: chatHash,
    },
    clientContext: {
      _c_646de49fccffcb4f19c17f5d: [userInfo.org_id],
      _c_646de503ccffcb4f19c18990: [userInfo.user_type],
      _c_646dddfc6424783a3f6cadde: [userInfo.orgPlan],
      _c_646de54eccffcb4f19c19197: userServiceId,
      _c_645c95d488b4a46be3f2c99f: [userInfo.org_name],
    },
    userContext: {
      _c_650ca62b974b905e0e801637: userServiceId,
    },
  };
  const t = window;
  const e = t.sprChat;
  const a = e && !!e.loaded;
  const n = document;
  const r = function () {
    r.m(arguments);
  };

  r.q = [];
  r.m = function (t) {
    r.q.push(t);
  };
  t.sprChat = a ? e : r;
  const e2 = t.sprTeamChat;
  const r2 = function () {
    r2.m(arguments);
  };
  r2.q = [];
  r2.m = function (t) {
    r2.q.push(t);
  };
  t.sprTeamChat = e2 ? e2 : r2;
  const o = function () {
    const e = n.createElement("script");
    e.type = "text/javascript";
    e.async = true;
    e.src = `${sprinklrChatUrl}` + t.sprChatSettings.appId;
    e.onerror = function () {
      t.sprChat.loaded = false;
    };
    e.onload = function () {
      t.sprChat.loaded = true;
      t.sprChat("subscribeToUpdate", {
        topic: "eventTriggered",
        subscriber: ({ response }) => {
          if (response?.data?.eventType === "CONVERSATION_WINDOW_OPENED") {
            toggleIsSprinklrChatOpen(true);
            const chatApp = document.getElementById("spr-live-chat-app");
            chatApp.style.display = "block";
          }
          if (response?.data?.eventType === "CONVERSATION_WINDOW_CLOSED") {
            const chatApp = document.getElementById("spr-live-chat-app");
            chatApp.style.display = "none";
            toggleIsSprinklrChatOpen(false);
          }
        },
      });
      t.sprChat("subscribeToUpdate", {
        topic: "loadCompleted",
        subscriber: () => {
          const chatApp = document.getElementById("spr-live-chat-app");
          chatApp.style.display = "none";
        },
      });
      t.sprChat("subscribeToUpdate", {
        topic: "unreadCountChanged",
        subscriber: ({
          response: {
            data: { count },
          },
        }) => {
          setSprinklrUnreadMessageCount(count);
        },
      });
    };
    const a = n.getElementsByTagName("script")[0];
    a.parentNode.insertBefore(e, a);
  };
  "function" == typeof e
    ? a
      ? e("update", t.sprChatSettings)
      : o()
    : "loading" !== n.readyState
    ? o()
    : n.addEventListener("DOMContentLoaded", o);
};

const openSprinklrChat = () => {
  if (window.sprChatSettings) {
    window.sprChat("open");
  }
};

export { loadSprinklr, openSprinklrChat };
